import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { RootProvider } from '../react-on-rails/RootProvider.js';
import { ApiReducer } from '../reducers/ApiReducer.js';
import { genericStoreSetup } from '../store/index.js';
import { hashHistory, Router, Route } from 'react-router';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';
var _excluded = ["createStore", "children", "initialState"];
/**
 * Generic Foundry App component
 *
 */

var App = function App(_ref) {
  var _ref$createStore = _ref.createStore,
      createStore = _ref$createStore === void 0 ? function (initialState) {
    return genericStoreSetup({
      api: ApiReducer,
      routing: routerReducer
    }, initialState);
  } : _ref$createStore,
      children = _ref.children,
      initialState = _ref.initialState,
      props = _objectWithoutProperties(_ref, _excluded);

  var store = createStore(initialState || {});
  var history = syncHistoryWithStore(hashHistory, store);

  var getChildRoutes = function getChildRoutes(routes) {
    if (!routes || !routes.length) {
      return null;
    }

    return routes.map(function (route) {
      return /*#__PURE__*/React.createElement(Route, _extends({
        key: route.routeKey
      }, props, route));
    });
  };

  return /*#__PURE__*/React.createElement(RootProvider, {
    store: store
  }, /*#__PURE__*/React.createElement(Router, {
    onUpdate: function onUpdate() {
      return window.scrollTo(0, 0);
    },
    history: history
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.createElement(Route, _extends({}, props, {
      path: child.props.path,
      component: function component(props) {
        return /*#__PURE__*/React.cloneElement(child, _objectSpread2({}, props));
      }
    }), getChildRoutes(child.props.routes));
  })));
};

App.displayName = "App";
App.propTypes = {
  children: PropTypes.node,
  createStore: PropTypes.func,
  initialState: PropTypes.object
};
export { App };